import PropTypes from 'prop-types'
import { Component } from 'react'

import Breadcrumbs from '../../../Header/breadcrumbs'

import './styles.scss'

export class NavBar extends Component {
  render () {
    const { children, /* breadCrumbs, */ logo } = this.props

    return (
      <nav id='scrollTop'>
        <div className='flex flex-row items-center gap-2 px-5 py-2 mt-1.5'>
          <div className='h-6 flex items-center'>{logo}</div>
          <div className='flex items-center relative -top-[6px]'>
            <Breadcrumbs />
          </div>
        </div>

        <div className='nav-section'>
          <div className='items'>{children}</div>
        </div>
      </nav>

    )
  }
}

NavBar.propTypes = {
  children: PropTypes.node,
  logo: PropTypes.node,
  noShadow: PropTypes.bool
}
